// Author Lin
// Date 2021-10-08 10:22:48

class MintalMesPrdSmeltingGasFlow {
constructor({
        id = null,
        locationId = '',
        shiftId = '',
        recordTime = '',
        actualPower1 = '',
        openDegree1 = '',
        flow1 = '',
        actualPower2 = '',
        openDegree2 = '',
        flow2 = '',
        actualPower3 = '',
        openDegree3 = '',
        flow3 = '',
        actualPower4 = '',
        openDegree4 = '',
        flow4 = '',
        intake1 = '',
        intake2 = '',
        cabinetPosition = '',
        remark = ''}
= {}) {
    this.id = id;
    this.locationId = locationId;
    this.shiftId = shiftId;
    this.recordTime = recordTime;
    this.actualPower1 = actualPower1;
    this.openDegree1 = openDegree1;
    this.flow1 = flow1;
    this.actualPower2 = actualPower2;
    this.openDegree2 = openDegree2;
    this.flow2 = flow2;
    this.actualPower3 = actualPower3;
    this.openDegree3 = openDegree3;
    this.flow3 = flow3;
    this.actualPower4 = actualPower4;
    this.openDegree4 = openDegree4;
    this.flow4 = flow4;
    this.intake1 = intake1;
    this.intake2 = intake2;
    this.cabinetPosition = cabinetPosition;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesPrdSmeltingGasFlow();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'locationName',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.grid.locationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'shiftName',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.grid.shiftName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'recordTime',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.grid.recordTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'actualPower1',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.grid.actualPower1',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'openDegree1',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.grid.openDegree1',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'flow1',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.grid.flow1',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'actualPower2',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.grid.actualPower2',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'openDegree2',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.grid.openDegree2',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'flow2',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.grid.flow2',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'actualPower3',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.grid.actualPower3',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'openDegree3',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.grid.openDegree3',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'flow3',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.grid.flow3',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'actualPower4',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.grid.actualPower4',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'openDegree4',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.grid.openDegree4',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'flow4',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.grid.flow4',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'intake1',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.grid.intake1',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'intake2',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.grid.intake2',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'cabinetPosition',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.grid.cabinetPosition',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    locationIdFilter : "",
    shiftIdFilter : "",
    recordTimeRteFilter : "",
    recordTimeLteFilter : "",
    actualPower1Filter : "",
    openDegree1Filter : "",
    flow1Filter : "",
    actualPower2Filter : "",
    openDegree2Filter : "",
    flow2Filter : "",
    actualPower3Filter : "",
    openDegree3Filter : "",
    flow3Filter : "",
    actualPower4Filter : "",
    openDegree4Filter : "",
    flow4Filter : "",
    intake1Filter : "",
    intake2Filter : "",
    cabinetPositionFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'locationIdFilter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.filter.locationId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'imfMstLocation'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'shiftIdFilter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.filter.shiftId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'imfMstShift'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'recordTimeRteFilter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.filter.recordTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'recordTimeLteFilter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.filter.recordTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'locationId',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.entity.locationId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'imfMstLocation'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'shiftId',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.entity.shiftId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'imfMstShift'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'recordTime',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.entity.recordTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'actualPower1',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.entity.actualPower1',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'openDegree1',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.entity.openDegree1',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'flow1',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.entity.flow1',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'actualPower2',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.entity.actualPower2',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'openDegree2',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.entity.openDegree2',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'flow2',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.entity.flow2',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'actualPower3',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.entity.actualPower3',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'openDegree3',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.entity.openDegree3',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'flow3',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.entity.flow3',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'actualPower4',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.entity.actualPower4',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'openDegree4',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.entity.openDegree4',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'flow4',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.entity.flow4',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'intake1',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.entity.intake1',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'intake2',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.entity.intake2',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'cabinetPosition',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.entity.cabinetPosition',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasFlow.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {MintalMesPrdSmeltingGasFlow, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
